import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { getBaseAPIUrl } from "../../request/config/api";
import { axiosBaseQuery } from "./baseQuery";
import { HYDRATE } from "../../utils/constants";
import { TagsType } from "../constants";
import { createCaptchaAxiosBaseQuery } from "./captchaRequired";

/*
  Создание запроса обёрнуто в функцию retry, так как в ряде ситуаций мы хотим делать повторные запросы.
  Например, когда сервер ответил непредвиденной ошибкой или отсутствует интернет-соединение.

  По-умолчанию maxRetries = 0, т.е. повторных запросов не происходит.
  Изменить эту настройку можно на уровне конкретного запроса (см. применение retryingRequestOptions в запросах).

  Ссылка на документацию: https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#automatic-retries
  NOTE: Дополнительно оборачиваем baseQuery в хэндлер 429 статуса с Captcha-Required: true
  ACQN-1351
*/
const axiosBaseQueryWithRetry = retry(
  createCaptchaAxiosBaseQuery(
    axiosBaseQuery({ baseUrl: getBaseAPIUrl() }),
    process.env.RECAPTCHA_KEY as string
  ),
  { maxRetries: 0 }
);

export const rtkqApi = createApi({
  reducerPath: "rtkqApi",
  /**
   * A bare bones base query would just be `baseQuery: fetchBaseQuery({ baseUrl: '/' })`
   */
  baseQuery: axiosBaseQueryWithRetry,
  /**
   * Tag types must be defined in the original API definition
   * for any tags that would be provided by injected endpoints
   */
  tagTypes: Object.values(TagsType) as `${TagsType}`[],
  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   * If you want all endpoints defined in the same file, they could be included here instead
   */
  endpoints: () => ({}),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
});

export interface TEntryData {
  endpointName: string;
  originalArgs: any;
  queryCacheKey: string;
}
